import React from "react";
import GridContainer from "@jumbo/components/GridContainer";
import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import AccessCheckElement from "./AccessCheckElement";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    marginTop: "30px",
    padding: "24px",
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  title: {
    color: theme.palette.primary.main,
    fontSize: "18px",
    fontWeight: "bold",
  },
}));

const accessListItems = [
  {
    name: "مدیر کارنامه",
    value: "ReportCard",
  },
  {
    name: "مدیر دسترسی",
    value: "AccessList",
  },
  {
    name: "مدیر بلاگ",
    value: "Blog",
  },
  {
    name: "مدیر چالش",
    value: "Challenge",
  },
  {
    name: "مدیر رخداد",
    value: "Event",
  },
  {
    name: "مدیر دسترسی رخداد",
    value: "EventToken",
  },
  {
    name: "مدیر فایل",
    value: "File",
  },
  {
    name: "مدیر گالری",
    value: "Gallery",
  },
  {
    name: "حذف فایل",
    value: "FileDelete",
  },
  {
    name: "مدیر گردونه شانس",
    value: "FortuneWheel",
  },
  {
    name: "مدیر دسترسی ثبت‌‌ نام",
    value: "MainAccessList",
  },
  {
    name: "مدیر جفت پوچ",
    value: "JoftPooch",
  },
  {
    name: "ماراتون  دانایی",
    value: "MarathonDanaie",
  },
  {
    name: "مدیر گزارش",
    value: "Report",
  },
  {
    name: "مدیر کاربر",
    value: "UserManager",
  },
  {
    name: "مدیر بنر",
    value: "Banner",
  },
  {
    name: "مدیر فرم",
    value: "Form",
  },
  {
    name: "مدیر پاسخ فرم",
    value: "FormFilled",
  },
  {
    name: "توکن امنیتی",
    value: "SecurityToken",
  },
  {
    name: "کلید",
    value: "Key",
  },
  {
    name: "ویترین جوایز",
    value: "PointShop",
  },
  {
    name: "امتیازها",
    value: "Score",
  },
  {
    name: "اعلان ها",
    value: "Notification",
  },
  {
    name: "تیکت ها",
    value: "SupportTicket",
  },
  {
    name: "مدیریت کلید جفت پوچ",
    value: "Coin",
  },
  {
    name: "هابل",
    value: "Hubble",
  },
  {
    name: "کلمه بازی",
    value: "WordGame",
  },
  {
    name: "مدیریت نذر",
    value: "Vow",
  },
  {
    name: "لاگ ادمین",
    value: "AdminLog",
  },
];

const AccessCheck = () => {
  const classes = useStyles();

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <GridContainer className={classes.girdContainer}>
          <Grid item xs={12}>
            <Typography className={classes.title}>مدیریت دسترسی</Typography>
          </Grid>
          {accessListItems.map((item, index) => (
            <AccessCheckElement
              itemName={item.name}
              itemVal={item.value}
              key={index}
            />
          ))}
        </GridContainer>
      </CmtCardContent>
    </CmtCard>
  );
};

export default AccessCheck;
